// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'trash';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M.75 3.75h16.5m-6.562-3H7.312a1.125 1.125 0 0 0-1.125 1.125V3.75h5.625V1.875A1.125 1.125 0 0 0 10.688.75zM7.313 13.313V7.686m3.375 5.627V7.686' />
    <path d='M14.145 16.215a1.118 1.118 0 0 1-1.117 1.035H4.972a1.118 1.118 0 0 1-1.117-1.035L2.813 3.75h12.375z' />
  </g>
);

export const viewBox = '0 0 18 18';
